<template>
    <div>
        <div class="df" style="width:100%;">
            <div class="left-box">
                <div class="tit1 df aic jcsb">
                    <span class="mic-semblod">{{ $t('热门帖子') }}</span>
                    <div class="redbox-btn">
                        <el-button type="primary" class="red-btn" @click="showModal()">{{ $t('发帖子') }}</el-button>
                    </div>
                </div>
                <div class="list-boxss">
                    <div class="list-box">
                        <!-- {{ hotlist }} -->

                        <div class="list" v-for="(item, index) in hotlist" @click="handleLink(item)">
                            <div class="titles one-text df aib">
                                <span class="montserrat-text fs-28 c-them mr-4" v-if="index + 1 < 3">
                                    {{ index + 1 }}.
                                </span>
                                <span class="mic-semblod"> {{ item.tp_title }}</span>
                            </div>
                            <div class="desc">
                                {{ item.tp_desc }}
                            </div>
                            <div class="userinfo-box df jcsb aic over-h">
                                <div class="users df aic f1 over-h">
                                    <div v-if="item.tp_type == 10" class="df"
                                        @click="(event) => handleaAvatar(event, item)">
                                        <template>
                                            <el-avatar :size="18" :src="item.user_avatar_att_url" class="fn"
                                                @error="true">
                                                <img src="@/assets/images/avatar.png" alt="">
                                            </el-avatar>
                                            <span class="name fn">{{ item.is_expert == 10 ? item.user_name :
                        item.user_nick_name }}</span>
                                        </template>
                                    </div>
                                    <template v-else>
                                        <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                            class="fn"></el-avatar>
                                        <span class="name fn">{{ $t('匿名用户') }}</span>
                                    </template>
                                    <div class="type one-text"
                                        v-if="item.user_excel_arr.length && item.user_excel_arr.length > 0">
                                        <span v-for="it in item.user_excel_arr">{{ it.label }}</span>
                                    </div>
                                </div>

                                <div class="dates df">
                                    <div class="comment-list df">
                                        <div class="li">
                                            <span class="iconfont">&#xe611;</span>
                                            <span class="text">{{ item.tp_hits }}</span>
                                        </div>
                                        <div class="li">
                                            <span class="iconfont">&#xe61b;</span>
                                            <span class="text">{{ item.tp_likes }}</span>
                                        </div>
                                        <div class="li">
                                            <span class="iconfont">&#xe63e;</span>
                                            <span class="text">{{ item.reply_count }}</span>
                                        </div>
                                    </div>
                                    <span class="date">{{ (item.tp_published_time) * 1000 | formatTime }}</span>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- 活跃用户 -->
            <div class="right-box">
                <div class="titles mic-semblod">{{ $t('活跃用户') }}</div>

                <div class="list-box">

                    <div class="list df aic" v-for="(item, index) in livelyUserList">
                        <div class="avatar-box df" @click="handleUserinfo(item)">
                            <el-avatar :size="52" :src="item.user_avatar_att_url" @error="errorHandler">
                                <img src="@/assets/images/avatar.png" alt="">
                            </el-avatar>
                        </div>
                        <div class="f1 r-box">
                            <div class="name">{{ item.user_nick_name }}</div>
                            <div class="lis df fww">
                                <div class="li">{{ $t('文章') }} {{ item.user_topic_article_count }}</div>
                                <div class="li">{{ $t('帖子') }} {{ item.user_post_count }}</div>
                                <div class="li">{{ $t('评论&回复') }} {{ item.user_ans_count }}</div>
                                <div class="li">{{ $t('提问') }} {{ item.user_act_que_count }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="activity-btns">
            <div class="more-btn">
                <el-button type="primary" class="more" @click="handleMore('/post/index')">{{ $t('查看更多') }}<span
                        class="iconfont">&#xe7e2;</span></el-button>
            </div>
        </div>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handlePostSubmitted" :id="id" />

        <!-- 发布帖子 -->
        <postModel ref="postDialog" :data="data" @post-submitted="handlePostModelSubmitted" />


    </div>
</template>

<script>
import { pathLoac } from "@config";
import { getpostList, getlivelyUserList, addApipost, setuserfollowAdd } from "@api/home";
// 发布帖子弹框
import postModel from '../../../components/postModel.vue';

export default {
    components: { postModel },
    props: {
        data: {
            type: Object, // 指定参数类型
            required: true // 是否为必需参数
        }
    },
    data() {
        return {
            // 热门话题
            hotlist: [

            ],

            livelyUserList: [], //活跃用户


            // 个人信息id
            id: 0,



        }
    },
    mounted() {
        this.getData();

    },
    methods: {

        handleaAvatar(event, item) {
            event.stopPropagation(); // 阻止事件冒泡
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;
        },

        handleMore(path) {

            let str = "/protal";

            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = "/protal_" + Language;
            }

            let url = str + path; // 你想要跳转的 URL
            window.open(url, '_blank');
        },

        // 打开发帖子
        showModal() {
            this.$refs.postDialog.openModal();
        },
        errorHandler() {
            return true
        },
        // 热门帖子详情
        handleLink(item) {
            let str = "/protal";

            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = "/protal_" + Language;
            }

            const url = str + '/post/info/id/' + item.tp_id; // 你想要跳转的 URL
            window.open(url, '_blank');
        },
        async getData() {
            let res = await getpostList();
            if (res.status == 200) {
                this.hotlist = res.data.hot_post_list;
            }

            let res1 = await getlivelyUserList();
            if (res1.status == 200) {
                this.livelyUserList = res1.data;

            }
        },
        handleUserinfo(item) {

            this.id = item.user_id;
            this.$refs.avatarDialog.openModal();
        },


        // 关注弹框用户
        async handlePostSubmitted(id) {
            // setuserfollowAdd
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
        },

        async handlePostModelSubmitted(content) {
            let res = await addApipost(content);
            if (res.status == 200) {
                this.$message.success(res.msg);
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.activity-btns {
    padding: 36px 80px 50px 0;
    text-align: center;

    .more-btn {
        position: relative;
    }

    .more {
        min-width: 106px;
        height: 36px;
        font-size: 14px;
        color: rgb(25, 25, 25);
        background-color: #ffffff;
        box-sizing: border-box;
        border: 0.5px solid rgb(0, 0, 0);
        border-radius: 20px;
        padding: 0 16px;

        .iconfont {
            font-size: 12px;
            color: #191919;
            margin-left: 5px;
        }

        &:hover {
            border: 0.5px solid rgb(183, 37, 30);
            color: rgb(183, 37, 30);

            .iconfont {
                color: rgb(183, 37, 30);
            }
        }
    }
}


.left-box {
    width: calc((100% - 80px) * 0.76);

    .tit1 {
        width: 100%;
        height: 36px;
        margin-bottom: 36px;

        span {
            color: rgb(25, 25, 25);
            font-size: 32px;
            font-weight: 400;
            line-height: 36px;
        }

        .redbox-btn {
            position: relative;
            right: 4px;

            &::after {
                content: "";
                display: block;
                width: 100%;
                height: 35px;
                border: 1px solid rgb(183, 37, 30);
                border-radius: 20px;
                position: absolute;
                top: 3px;
                left: 4px;
                transition: all 0s;
                z-index: 1;
            }

            &:hover {
                &::after {
                    border: 1px solid rgb(221, 115, 109);
                }

                .red-btn {
                    background-color: #DD736D;
                }
            }
        }

        .red-btn {
            min-width: 92px;
            height: 35px;
            line-height: 35px;
            padding: 0 12px;
            border-radius: 20px;
            letter-spacing: 1px;
            border: none;
            position: relative;
            z-index: 10;





        }
    }

    .list-boxss {
        position: relative;
        z-index: 1;

        &::after {
            content: '';
            display: block;
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            background: linear-gradient(180deg, #F2DBDA, #F2DBDA, #fff9f9);
            z-index: -1;
            border-radius: 14px;
            padding: 5px;
            box-sizing: border-box;
        }
    }

    .list-box {
        padding: 24px;
        border-radius: 12px;
        background: linear-gradient(180.00deg, #FCF7F6 40.357%, #FFFEFE 60%, #ffffff 100%);
        position: relative;
        z-index: 1;



        .list {
            padding: 16px;
            border-bottom: 1px solid rgb(226, 226, 226);
            cursor: pointer;

            &:hover {
                .titles {
                    color: #b7251e;
                }
            }

            &:last-child {
                border-bottom: none;
            }
        }

        .titles {
            color: rgb(25, 25, 25);
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            transition: color .36s;
        }

        .desc {
            color: rgb(51, 51, 51);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            margin-top: 9px;
        }

        .userinfo-box {
            height: 32px;
            margin-top: 8px;

            .name {
                font-size: 14px;
                margin-left: 6px;
            }
        }

        .type {
            height: 32px;
            position: relative;
            margin-left: 18px;
            padding: 5px 18px;

            &::after {
                content: "";
                display: block;
                height: 14px;
                width: 1px;
                background-color: #D8D8D8;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                left: 0;
            }

            span {
                display: inline-block;
                height: 22px;
                background-color: #F0F1F1;
                border-radius: 4px;
                padding: 0 4px;
                color: #868D9F;
                line-height: 22px;
                font-size: 12px;
                margin-right: 6px;
            }
        }

        .dates {
            height: 32px;
            line-height: 32px;

            .date {
                font-size: 14px;
                color: #868D9F;
                position: relative;
                padding-left: 16px;

                &::after {
                    content: "";
                    display: inline-block;
                    height: 12px;
                    width: 1px;
                    background-color: #D8D8D8;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    margin-top: -6px;
                }
            }

            .comment-list {
                .li {
                    color: #868D9F;
                    font-size: 14px;
                    margin-right: 15px;

                    .iconfont {
                        margin-right: 5px;
                    }

                    .text {}
                }
            }
        }
    }
}

.right-box {
    width: calc((100% - 80px) * 0.24);
    margin: 0 40px;

    .titles {
        color: rgb(25, 25, 25);
        font-size: 32px;
        font-weight: 400;
        line-height: 36px;
    }

    .list-box {
        margin-top: 36px;
    }

    .list {
        margin-bottom: 10px;

        .avatar-box {
            position: relative;
            cursor: pointer;

            &::after {
                content: "";
                display: block;
                box-sizing: content-box;
                width: 56px;
                height: 56px;
                border-radius: 50%;
                border: 1px solid #8DADEE;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            &::before {
                content: "";
                display: block;
                box-sizing: content-box;
                width: 63px;
                height: 63px;
                border-radius: 50%;
                border: 1px solid #D4E0F9;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        &:last-child {
            margin-bottom: 0px;
        }

        .lis {
            width: 100%;

            .li {
                width: 50%;
                font-size: 14px;
                color: #868D9F;
                line-height: 24px;
            }
        }

        .r-box {
            margin-left: 16px;
        }

        .name {
            font-size: 16px;
            line-height: 32px;
            margin-top: 3px;
        }
    }
}
</style>